import { render, staticRenderFns } from "./PersonManagementModal.vue?vue&type=template&id=797fbb55&scoped=true&"
import script from "./PersonManagementModal.vue?vue&type=script&lang=js&"
export * from "./PersonManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./PersonManagementModal.vue?vue&type=style&index=0&id=797fbb55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fbb55",
  null
  
)

export default component.exports